import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import baseAxios from 'src/utils/baseAxios'
import moment from 'moment';

// Thunks
export const GetEmployees = createAsyncThunk('/GetEmployees', async () => {
    const response = await baseAxios.get(`Payment/Employees`);
    return response.data;
});

export const GetStatuses = createAsyncThunk('/GetStatuses', async () => {
    const response = await baseAxios.get(`Payment/Statuses`);
    return response.data;
});



export const CreatePaymentSession = createAsyncThunk(
    'payment/CreatePaymentSession',
    async (paymentData, { rejectWithValue }) => {
        try {
            const response = await baseAxios.post('Payment/create-session', paymentData);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const ProductPreSale = createAsyncThunk(
    'payment/ProductPreSale',
    async (paymentData, { rejectWithValue }) => {
        try {
            const response = await baseAxios.post('Payment/ProductPreSale', paymentData);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const WarrantyPreSales = createAsyncThunk(
    'payment/WarrantyPreSales',
    async (paymentData, { rejectWithValue }) => {
        try {
            const response = await baseAxios.post('Payment/WarrantyPreSales', paymentData);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const SearchPayments = createAsyncThunk(
    'payment/SearchPayments',
    async (dto, { rejectWithValue }) => {
        try {
            // Query string oluşturuluyor
            const params = new URLSearchParams([
                ['EmployeeId', dto.EmployeeId],
                ['StatusId', dto.StatusId],
                ['CreateDate', moment(dto.CreateDate).format('YYYY-MM-DD')]
            ]);

            const response = await baseAxios.get(`Payment/paymentData`, { params });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const ResendProcessPayment = createAsyncThunk(
    'payment/ResendProcessPayment',
    async (dto, { rejectWithValue }) => {
        try {
            await baseAxios.post('Payment/resend', dto);
            return true; // Başarılı olursa true döndür
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const GetSironexActivatedTenants = createAsyncThunk('/GetSironexActivatedTenants', async () => {
    const response = await baseAxios.get(`Payment/activatedTenants`);
    return response.data;
});

export const GetProductTenantSales = createAsyncThunk('/GetProductTenantSales', async () => {
    const response = await baseAxios.get(`Payment/productTenantSales`);
    return response.data;
});
// WorkOrder doğrulama
export const VerifyWorkOrder = createAsyncThunk(
  '/VerifyWorkOrder',
  async (workOrderId, { rejectWithValue }) => {
    try {
      const response = await baseAxios.get(`Payment/verifyWorkOrder/${workOrderId}`);
      return response.data; // ResponseDto<VerifyWorkOrderDto>
    } catch (e) {
      return rejectWithValue(e.response?.data || e.message);
    }
  }
);
export const GetProductOrderList = createAsyncThunk(
  '/GetProductOrderList',
  async (_, { rejectWithValue }) => {
    try {
      const response = await baseAxios.get(`Payment/GetProductOrderList`);
      return response.data; // List<ProductOrderDto>
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
// New: CreateCustomer
export const CreateCustomer = createAsyncThunk(
  'payment/CreateCustomer',
  async (consumerDto, { rejectWithValue }) => {
    try {
      const response = await baseAxios.post('Payment/CreateCustomer', consumerDto);
      return response.data; // ResponseDto<ConsumerDto>
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
// New: SearchConsumer (GET /payment/SearchConsumer/{consumerName})
export const SearchConsumer = createAsyncThunk(
  'payment/SearchConsumer',
  async (consumerName, { rejectWithValue }) => {
    try {
      const response = await baseAxios.get(`Payment/SearchConsumer/${encodeURIComponent(consumerName)}`);
      return response.data; // List<ConsumerDto>
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
// New: CreateProductOrder (POST /payment/CreateProductOrder)
export const CreateProductOrder = createAsyncThunk(
  'payment/CreateProductOrder',
  async (dto, { rejectWithValue }) => {
    try {
      const response = await baseAxios.post('Payment/CreateProductOrder', dto);
      return response.data; // int (created order id)
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
// New: GetEmployeePosMatching (GET /payment/GetEmployeePosMatching/{employeeId})
export const GetEmployeePosMatching = createAsyncThunk(
  'payment/GetEmployeePosMatching',
  async (employeeId, { rejectWithValue }) => {
    try {
      const response = await baseAxios.get(`Payment/GetEmployeePosMatching/${employeeId}`);
      return response.data; // ResponseDto<List<EmployeePosMatchingDto>>
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// New: RepairPreSale (POST /payment/RepairPreSale)
export const RepairPreSale = createAsyncThunk(
  'payment/RepairPreSale',
  async (dto, { rejectWithValue }) => {
    try {
      const response = await baseAxios.post('Payment/RepairPreSale', dto);
      return response.data; // CreatePaymentSessionResponseDto
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// New: GetRepairOrderCondition (GET /payment/GetRepairOrderCondition)
export const GetRepairOrderCondition = createAsyncThunk(
  'payment/GetRepairOrderCondition',
  async (_, { rejectWithValue }) => {
    try {
      const response = await baseAxios.get('Payment/GetRepairOrderCondition');
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// New: GetConsumerInfo (GET /payment/GetConsumerInfo/{consumerId})
export const GetConsumerInfo = createAsyncThunk(
  'payment/GetConsumerInfo',
  async (consumerId, { rejectWithValue }) => {
    try {
      const response = await baseAxios.get(`Payment/GetConsumerInfo/${consumerId}`);
      return response.data; // ResponseDto<ConsumerDto>
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// New: GetPosTenantVatRate (GET /payment/GetPosTenantVatRate)
export const GetPosTenantVatRate = createAsyncThunk(
  'payment/GetPosTenantVatRate',
  async (_, { rejectWithValue }) => {
    try {
      const response = await baseAxios.get('Payment/GetPosTenantVatRate');
      return response.data; // ResponseDto<PosTenantVatRateDto>
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const paymentSlice = createSlice({
    name: 'payment',
    initialState: {
        employeeList: [],
        selectedEmployee: null,
        statusList: [],
        selectedStatus: null,
        selectedCreateDate: moment()
            .startOf('day')
            .format('YYYY-MM-DD'),
        paymentSessionData: null,
        paymentUrl: null,
        paymentDataList: [],
        loading: 'idle',
        error: null,
        activatedTenants: [],
        productTenantSales: [],
        verifyWorkOrderLoading: 'idle',
        verifyWorkOrderData: null,
        verifyWorkOrderError: null,
        productSKU: '',
        productPrice: '',
        workOrderId: '',          // doğrulanan / girilen workOrder
        paymentInitiated: false, // Proceed butonuna basıldı mı
        productId: 0,           // eklenen ürün
        productOrderList: [],
        createdCustomer: null,
        createCustomerLoading: 'idle',
        createCustomerError: null,
        consumerSearchResults: [],
        consumerSearchLoading: 'idle',
        consumerSearchError: null,
        createdProductOrderId: null,
        createProductOrderLoading: 'idle',
        createProductOrderError: null,
        verifiedCustomerId: null,
        consumerInfoData: null,
        consumerInfoLoading: 'idle',
        consumerInfoError: null,
        afterSaleData: null,
        afterSaleLoading: 'idle',
        afterSaleError: null,
        repairPreSaleData: null,
        repairPreSaleLoading: 'idle',
        repairPreSaleError: null,
        employeePosMatchingList: [],
        employeePosMatchingLoading: 'idle',
        employeePosMatchingError: null,
        repairOrderConditions: [],
        repairOrderConditionsLoading: 'idle',
        repairOrderConditionsError: null,
        countryVatRate: null,
        posTenantVatRate: null,
        posTenantVatRateLoading: 'idle',
        posTenantVatRateError: null
    },
    reducers: {
        setSelectedEmployee: (state, action) => {
            state.selectedEmployee = action.payload;
        },
        setSelectedStatus: (state, action) => {
            state.selectedStatus = action.payload;
        },
        setSelectedCreateDate: (state, action) => {
            state.selectedCreateDate = action.payload;
        },
        clearPaymentError: (state) => {
            state.error = null;
            // New: also clear create customer error
            state.createCustomerError = null;
        },
        clearPaymentData: (state) => {
            state.paymentSessionData = null;
            state.paymentUrl = null;
            state.error = null;
        },
        clearPaymentDataList: (state) => {
            state.paymentDataList = [];
            state.error = null;
        },
        clearVerifyWorkOrder: (state) => {
            state.verifyWorkOrderData = null;
            state.verifyWorkOrderError = null;
            state.verifyWorkOrderLoading = 'idle';
            // New: also clear verified customer id
            state.verifiedCustomerId = null;
        },
        setProductSKU: (state, action) => { state.productSKU = action.payload || ''; },
        setProductPrice: (state, action) => { state.productPrice = action.payload || ''; },
        setWorkOrderId: (state, action) => { state.workOrderId = action.payload || ''; },
        clearProductSelection: (state) => {
          state.productSKU = '';
          state.productPrice = '';
          state.productId = 0;
        },
        setPaymentInitiated: (state, action) => {
          state.paymentInitiated = !!action.payload;
        },
        setProductId: (state, action) => { state.productId = action.payload || 0; },
        // New: clear created customer
        clearCreatedCustomer: (state) => {
          state.createdCustomer = null;
          state.createCustomerLoading = 'idle';
          state.createCustomerError = null;
        },
        // Optional: clear consumer search state
        clearConsumerSearch: (state) => {
          state.consumerSearchResults = [];
          state.consumerSearchLoading = 'idle';
          state.consumerSearchError = null;
        },
        // New: clear created product order
        clearCreatedProductOrder: (state) => {
          state.createdProductOrderId = null;
          state.createProductOrderLoading = 'idle';
          state.createProductOrderError = null;
        },
        clearConsumerInfo: (state) => {
          state.consumerInfoData = null;
          state.consumerInfoLoading = 'idle';
          state.consumerInfoError = null;
        },
        // New: setter to persist selected consumer id
        setVerifiedCustomerId: (state, action) => {
          state.verifiedCustomerId = action.payload || null;
        },
        clearAfterSale: (state) => {
          state.afterSaleData = null;
          state.afterSaleLoading = 'idle';
          state.afterSaleError = null;
        },
        clearRepairPreSale: (state) => {
          state.repairPreSaleData = null;
          state.repairPreSaleLoading = 'idle';
          state.repairPreSaleError = null;
        },
        clearEmployeePosMatching: (state) => {
          state.employeePosMatchingList = [];
          state.employeePosMatchingLoading = 'idle';
          state.employeePosMatchingError = null;
        },
        setCountryVatRate: (state, action) => {
          state.countryVatRate = action.payload ?? null;
        },
    },
    extraReducers: {
        [GetEmployees.pending]: (state) => {
            state.loading = 'Loading';
        },
        [GetEmployees.rejected]: (state, action) => {
            state.error = action.payload;
            state.loading = 'Finished';
        },
        [GetEmployees.fulfilled]: (state, action) => {
            state.employeeList = Array.isArray(action.payload) ? action.payload : [];
            state.loading = 'Finished';
        },
        [GetStatuses.pending]: (state) => {
            state.loading = 'Loading';
        },
        [GetStatuses.rejected]: (state, action) => {
            state.error = action.payload;
            state.loading = 'Finished';
        },
        [GetStatuses.fulfilled]: (state, action) => {
            state.statusList = Array.isArray(action.payload) ? action.payload : [];
            state.loading = 'Finished';
        },
        [CreatePaymentSession.pending]: (state) => {
            state.loading = 'Loading';
        },
        [CreatePaymentSession.rejected]: (state, action) => {
            state.error = action.payload;
            state.loading = 'Finished';
        },
        [CreatePaymentSession.fulfilled]: (state, action) => {
            state.paymentSessionData = action.payload;
            state.paymentUrl = action.payload.PaymentUrl;
            state.loading = 'Finished';
        },
        [WarrantyPreSales.pending]: (state) => {
            state.loading = 'Loading';
        },
        [WarrantyPreSales.rejected]: (state, action) => {
            state.error = action.payload;
            state.loading = 'Finished';
        },
        [WarrantyPreSales.fulfilled]: (state, action) => {
            state.paymentSessionData = action.payload;
            state.paymentUrl = action.payload.PaymentUrl;
            state.loading = 'Finished';
        },
        [SearchPayments.pending]: (state) => {
            state.loading = 'Loading';
        },
        [SearchPayments.rejected]: (state, action) => {
            state.error = action.payload;
            state.loading = 'Finished';
        },
        [SearchPayments.fulfilled]: (state, action) => {
            state.paymentDataList = Array.isArray(action.payload) ? action.payload : [];
            state.loading = 'Finished';
        },
        [ResendProcessPayment.pending]: (state) => {
            state.loading = 'Loading';
        },
        [ResendProcessPayment.rejected]: (state, action) => {
            state.error = action.payload;
            state.loading = 'Finished';
        },
        [ResendProcessPayment.fulfilled]: (state) => {
            state.loading = 'Finished';
        },
        [GetSironexActivatedTenants.pending]: (state) => {
            state.loading = 'Loading';
        },
        [GetSironexActivatedTenants.rejected]: (state, action) => {
            state.error = action.payload;
            state.loading = 'Finished';
        },
        [GetSironexActivatedTenants.fulfilled]: (state, action) => {
            state.activatedTenants = Array.isArray(action.payload) ? action.payload : [];
            state.loading = 'Finished';
        },
        [GetProductTenantSales.pending]: (state) => {
            state.loading = 'Loading';
        },
        [GetProductTenantSales.rejected]: (state, action) => {
            state.error = action.payload;
            state.loading = 'Finished';
        },
        [GetProductTenantSales.fulfilled]: (state, action) => {
            state.productTenantSales = Array.isArray(action.payload) ? action.payload : [];
            state.loading = 'Finished';
        },
        [VerifyWorkOrder.pending]: (state) => {
            state.verifyWorkOrderLoading = 'Loading';
            state.verifyWorkOrderError = null;
            state.verifyWorkOrderData = null;
        },
        [VerifyWorkOrder.rejected]: (state, action) => {
            state.verifyWorkOrderLoading = 'Finished';
            state.verifyWorkOrderError = action.payload;
        },
        [VerifyWorkOrder.fulfilled]: (state, action) => {
            state.verifyWorkOrderLoading = 'Finished';
            state.verifyWorkOrderData = action.payload;
            // New: extract CustomerId from response
            const ro = action.payload?.ResponseObject;
            state.verifiedCustomerId = (ro?.CustomerId ?? action.payload?.CustomerId ?? null) || null;
        },
        [ProductPreSale.pending]: (state) => {
            state.loading = 'Loading';
        },
        [ProductPreSale.rejected]: (state, action) => {
            state.error = action.payload;
            state.loading = 'Finished';
        },
        [ProductPreSale.fulfilled]: (state, action) => {
            state.paymentSessionData = action.payload;
            state.paymentUrl = action.payload.PaymentUrl;
            state.loading = 'Finished';
        },
        [GetProductOrderList.pending]: (state) => {
            state.loading = 'Loading';
        },
        [GetProductOrderList.rejected]: (state, action) => {
            state.error = action.payload;
            state.loading = 'Finished';
        },
        [GetProductOrderList.fulfilled]: (state, action) => {
            state.productOrderList = Array.isArray(action.payload) ? action.payload : [];
            state.loading = 'Finished';
        },
        // New: CreateCustomer handlers
        [CreateCustomer.pending]: (state) => {
          state.createCustomerLoading = 'Loading';
          state.createCustomerError = null;
          state.createdCustomer = null;
        },
        [CreateCustomer.rejected]: (state, action) => {
          state.createCustomerLoading = 'Finished';
          state.createCustomerError = action.payload;
        },
        [CreateCustomer.fulfilled]: (state, action) => {
          state.createCustomerLoading = 'Finished';
          state.createdCustomer = action.payload;
        },
        // New: SearchConsumer handlers
        [SearchConsumer.pending]: (state) => {
          state.consumerSearchLoading = 'Loading';
          state.consumerSearchError = null;
          state.consumerSearchResults = [];
        },
        [SearchConsumer.rejected]: (state, action) => {
          state.consumerSearchLoading = 'Finished';
          state.consumerSearchError = action.payload;
        },
        [SearchConsumer.fulfilled]: (state, action) => {
          state.consumerSearchLoading = 'Finished';
          state.consumerSearchResults = Array.isArray(action.payload) ? action.payload : [];
        },
        // New: CreateProductOrder handlers
        [CreateProductOrder.pending]: (state) => {
          state.createProductOrderLoading = 'Loading';
          state.createProductOrderError = null;
          state.createdProductOrderId = null;
        },
        [CreateProductOrder.rejected]: (state, action) => {
          state.createProductOrderLoading = 'Finished';
          state.createProductOrderError = action.payload;
        },
        [CreateProductOrder.fulfilled]: (state, action) => {
          state.createProductOrderLoading = 'Finished';
          state.createdProductOrderId = typeof action.payload === 'number' ? action.payload : null;
        },
        // New: GetConsumerInfo handlers
        [GetConsumerInfo.pending]: (state) => {
          state.consumerInfoLoading = 'Loading';
          state.consumerInfoError = null;
          state.consumerInfoData = null;
        },
        [GetConsumerInfo.rejected]: (state, action) => {
          state.consumerInfoLoading = 'Finished';
          state.consumerInfoError = action.payload;
        },
        [GetConsumerInfo.fulfilled]: (state, action) => {
          state.consumerInfoLoading = 'Finished';
          state.consumerInfoData = action.payload;
        },
        // New: RepairPreSale handlers
        [RepairPreSale.pending]: (state) => {
          state.repairPreSaleLoading = 'Loading';
          state.repairPreSaleError = null;
          state.repairPreSaleData = null;
        },
        [RepairPreSale.rejected]: (state, action) => {
          state.repairPreSaleLoading = 'Finished';
          state.repairPreSaleError = action.payload;
        },
        [RepairPreSale.fulfilled]: (state, action) => {
          state.repairPreSaleLoading = 'Finished';
          state.repairPreSaleData = action.payload;
        },
        // New: GetEmployeePosMatching handlers
        [GetEmployeePosMatching.pending]: (state) => {
          state.employeePosMatchingLoading = 'Loading';
          state.employeePosMatchingError = null;
          state.employeePosMatchingList = [];
        },
        [GetEmployeePosMatching.rejected]: (state, action) => {
          state.employeePosMatchingLoading = 'Finished';
          state.employeePosMatchingError = action.payload;
        },
        [GetEmployeePosMatching.fulfilled]: (state, action) => {
          state.employeePosMatchingLoading = 'Finished';
          const data = action.payload;
          // Handle ResponseDto<List<EmployeePosMatchingDto>> or plain array
          state.employeePosMatchingList = Array.isArray(data) ? data
            : (Array.isArray(data?.ResponseObject) ? data.ResponseObject
            : (Array.isArray(data?.Result) ? data.Result : []));
        },
        // GetRepairOrderCondition handlers
        [GetRepairOrderCondition.pending]: (state) => {
          state.repairOrderConditionsLoading = 'Loading';
          state.repairOrderConditionsError = null;
        },
        [GetRepairOrderCondition.rejected]: (state, action) => {
          state.repairOrderConditionsLoading = 'Finished';
          state.repairOrderConditionsError = action.payload;
        },
        [GetRepairOrderCondition.fulfilled]: (state, action) => {
          state.repairOrderConditionsLoading = 'Finished';
          const data = action.payload;
          state.repairOrderConditions = Array.isArray(data) ? data
            : (Array.isArray(data?.ResponseObject) ? data.ResponseObject
            : (Array.isArray(data?.Result) ? data.Result : []));
        },
        [GetPosTenantVatRate.pending]: (state) => {
          state.posTenantVatRateLoading = 'Loading';
          state.posTenantVatRateError = null;
          state.posTenantVatRate = null;
        },
        [GetPosTenantVatRate.rejected]: (state, action) => {
          state.posTenantVatRateLoading = 'Finished';
          state.posTenantVatRateError = action.payload;
        },
        [GetPosTenantVatRate.fulfilled]: (state, action) => {
          state.posTenantVatRateLoading = 'Finished';
          state.posTenantVatRate = action.payload; // ResponseDto<PosTenantVatRateDto>
        }
    }
});

export const paymentActions = paymentSlice.actions;
export const paymentThunks = {
    CreatePaymentSession,
    GetEmployees,
    GetStatuses,
    WarrantyPreSales,
    SearchPayments,
    ResendProcessPayment,
    GetSironexActivatedTenants,
    GetProductTenantSales,
    VerifyWorkOrder,
    ProductPreSale,
    GetProductOrderList,
    CreateCustomer,
    SearchConsumer,
    CreateProductOrder,
    GetConsumerInfo,
    RepairPreSale,
    GetEmployeePosMatching,
    GetRepairOrderCondition,
    GetPosTenantVatRate
};

export default paymentSlice.reducer;

